import { AppBar, AppBarProps } from 'react-admin';
import { Typography, useMediaQuery, Theme, Box } from '@mui/material';
import Logo from './Logo';
import { GlobalSearch } from './GlobalSearch';
import { InboxAppBarButton } from '../inbox/InboxAppBarButton';

export const MyAppbar = (props: AppBarProps) => {
  const isLargeEnough = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up('sm')
  );

  return (
    <AppBar {...props}>
      <Typography
        variant="h6"
        color="inherit"
        sx={{
          flex: 1,
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
        id="react-admin-title"
      />
      {isLargeEnough && <Logo />}
      {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
      <GlobalSearch />
      <InboxAppBarButton />
    </AppBar>
  );
};
